import { CopywritingChannel } from "@/pages/Private/pages/Messages/components/GenerateBar/types";

import { findMeAmongSenders, pickDefaultMailbox } from "./resolveMyDefaultSender.util";

import type { User } from "@/pages/Public/pages/Login/schema/login";

export interface DefaultGenerateSender {
	senderUserId: number;
	senderEmailId?: number;
	channel: CopywritingChannel;
	linkedinInviteNote: boolean;
}

/**
 * Resolves who a direct ("no modal") draft generation writes as — the Feed's Generate. The
 * generation sender becomes the drafts' sender, so it follows the composer's default rule
 * (PREC-4312): the current user or nobody, never a colleague.
 *   - With a LinkedIn session, for a lead with a LinkedIn profile: the combined sequence (LinkedIn
 *     invite with a note, then email), as it always was; the email id is the one email rule's
 *     mailbox ({@link pickDefaultMailbox}).
 *   - Otherwise, for a lead with an email address: an email sequence from that mailbox (E1/E2).
 *
 * Returns `null` only when the current user has nothing that reaches the lead; the caller says so.
 */
export const resolveDefaultGenerateSender = (
	sendingUsers: User[] | undefined,
	currentUserId: number | undefined,
	lead: { prospectHasEmail: boolean; prospectHasLinkedinUrl: boolean }
): DefaultGenerateSender | null => {
	const me = findMeAmongSenders(sendingUsers, currentUserId);
	const mailbox = pickDefaultMailbox(me?.emails);

	if (me?.unipile?.isLoggedIn && lead.prospectHasLinkedinUrl) {
		return {
			senderUserId: me.id,
			senderEmailId: mailbox?.id,
			channel: CopywritingChannel.BOTH,
			linkedinInviteNote: true,
		};
	}

	if (me && mailbox && lead.prospectHasEmail) {
		return {
			senderUserId: me.id,
			senderEmailId: mailbox.id,
			channel: CopywritingChannel.EMAIL,
			linkedinInviteNote: false,
		};
	}

	return null;
};
